export default "__VITE_ASSET__010019c0__"